import { MapInformationService } from 'src/app/services/map-information.service';
// import { NavbarSidebarComponent } from 'src/app/shared/navbar-sidebar/navbar-sidebar.component';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-applications',
  templateUrl: './applications.component.html',
  styleUrls: ['./applications.component.scss']
})

export class ApplicationsComponent implements OnInit {
  menuItems = [
    // {
    //      text: 'HOME'
    //  },
    //   {
    //      text: 'PRODUCTS',

    //  }, 
     {
         text: 'APPLICATIONS'
     }];

     galleryDataSource = [
        { path: "assets/mac.jpg" },
        { path: "assets/person-music1100x700.jpg" }

   ];

   tileViewData = [
      { name: "Product Name 1" },
      { name: "Product Name 2"},
      { name: "Product Name 3" },
      { name: "Product Name 4"}

      // ...
  ];

  dataSource:any[]=[]

  openFullScreen:boolean = true
  SystemIDSelected:any
  estimateIDSelected:any
  estimatenamestrSelected:any
  projectIDSelected:any

  screen(width) {
       return ( width < 700 ) ? 'sm' : 'lg';
   }
  constructor(
    private MapInformationService:MapInformationService,
    private router: Router, 

    // public NavbarSidebarComponent:NavbarSidebarComponent
    
    ) { 

      // this.NavbarSidebarComponent.ApplicationsComponentFunctions = this
    }

  ngOnInit() {
    this.getApplications()

    this.estimateIDSelected = localStorage.getItem("estimateIDSelected")
    this.estimatenamestrSelected = localStorage.getItem("estimatenamestrSelected")
    this.projectIDSelected = localStorage.getItem("projectIDSelected")
  }


  getApplications(){
    console.log("aqui")
    this.MapInformationService.SaveInfoSites({method:"Get_EcomMainCategoriesAp_CR"})
    .subscribe(resp=>{
      console.log(resp)
      let dataTemporal = []
      let contador = 0
      resp.forEach(element => {
        if (element.CATIMAGE != "MCNoImage.JPG" && element.CATIMAGE != undefined){
          this.MapInformationService.DowloadDocumentlowQuality(element.CATIMAGE).subscribe(result => {
  
            let tipo = ""
            let data = ""
            
            if (result.filestring != undefined){
              data = result.filestring.substring(0, 5);
            } else {
              data = ""
            }
            
            console.log(data.toUpperCase())
      
            switch(data.toUpperCase()){
              case "IVBOR":tipo = "png";
              break
              case "/9J/4":tipo = "jpg";
              break
              case "JVBER":tipo = "pdf";
              break
              case "UESDB":
                var data2 = result.filestring.substring(0, 19);
                switch(data.toUpperCase()){
                  case "UEsDBBQABgAIAAAAIQB":tipo = "xlsx";
                  break
                  default:
                    var data3 = result.filestring.substring(0, 18);
                    switch(data.toUpperCase()){
                      case "UEsDBBQABgAIAAAAIQ":tipo = "docx";
                      break
                      default:tipo = "zip";
                    }
                }
              break
              case "UMFYI":tipo = "rar";
              break
              case "U1PKC":tipo = "txt";
              break
            }

            element.base64 = result.filestring == "" ? "Not_image" : result.filestring
            element.tipo = result.filestring == "" ? "png" : tipo
            // element.base64 = "Not_image"
            // element.tipo = "png"
            dataTemporal.push(element)
            contador++
            if (contador == resp.length) {
              this.dataSource = dataTemporal.sort((a, b) => {
                const valueA = a.SystemType.toLowerCase();
                const valueB = b.SystemType.toLowerCase();
            
                if (valueA < valueB) {
                  return -1;
                } else if (valueA > valueB) {
                  return 1;
                } else {
                  return 0;
                }
              });
              console.log(this.dataSource)
            }

          });
        } else {
          contador++
          element.base64 = "Not_image"
          element.tipo = "png"
          dataTemporal.push(element)
          if (contador == resp.length) {
            this.dataSource = dataTemporal.sort((a, b) => {
              const valueA = a.SystemType.toLowerCase();
              const valueB = b.SystemType.toLowerCase();
          
              if (valueA < valueB) {
                return -1;
              } else if (valueA > valueB) {
                return 1;
              } else {
                return 0;
              }
            });
            console.log(this.dataSource)
          }
        }
      })
    })
  }

  itemClick(e) {
    if (e.itemData.text == 'HOME'){
      this.router.navigateByUrl('/productsCart');
    }
    if (e.itemData.text == 'PRODUCTS'){
      // this.router.navigateByUrl('/productsCategory');
      this.router.navigateByUrl('/products');
    }
    if (e.itemData.text == 'APPLICATIONS'){
      this.router.navigateByUrl('/applications');
    }
    console.log(e);
  }

  goToProduct(info){
    console.log(info)
    this.router.navigate(['/ApplicationType'], { queryParams: { id: info.ID } });
  }

  SelectCategory(item){
    console.log(item)
    if(item.NumberOfChild > 0){
      this.router.navigate(['/ApplicationType'], { queryParams: { parentID: item.ID, nameApplication: item.SystemType } });
    } else {
      if(item.NumberOfSystems > 0){
        this.router.navigate(['/ListSystems'], { queryParams: { id: item.ID, nameChild: item.SystemType, parentID: item.ID, nameParent: item.SystemType} });
      } else {
        console.log('error')
      }
    }
  }

  goBackEstimate(){
    console.log("back")

    this.router.navigate(['/Estimates/editEstimate'], { queryParams: { numESTIMATEID: this.estimateIDSelected, numProjectID:this.projectIDSelected, strPROJECT_NAME:this.estimatenamestrSelected} });
  }

}
